<div class="row" style="margin-top: -0.5rem">
  <div class="col-12 d-flex">
    <div class="card flex-fill border-0 bg-white shadow-lg">
      <div class="card-body pt-2 pb-2">
        <h4 class="mb-2 font-bold">Sistema de Alerta de Doenças</h4>
        <div class="row g-2 mb-0">
          <!-- Card 1 - Aviso de Alerta de Ferrugem -->
          <div class="col-md-4">
            <app-dashboard-metric-card
              titleCard="Aviso de alerta de ferrugem"
              [value]="rustAlertCount.toString()"
              description="Necessitam de atenção"
              type="primary"
              buttonLabel="Verificar Informações"
              buttonRoute="/sad/ferrugem"
              [isLoading]="isLoadingRustAlert"
              [useConditionalColor]="true"
            >
            </app-dashboard-metric-card>
          </div>

          <!-- Card 2 - Aviso de Alerta de Phoma -->
          <div class="col-md-4">
            <app-dashboard-metric-card
              titleCard="Aviso de alerta de phoma"
              [value]="phomaAlertCount.toString()"
              description="Necessitam de atenção"
              type="primary"
              buttonLabel="Verificar Informações"
              buttonRoute="/sad/phoma"
              [isLoading]="isLoadingPhomaAlert"
              [useConditionalColor]="true"
            >
            </app-dashboard-metric-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
